var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    display: 'block',
    backgroundImage: `url('${_vm.src}')`,
    paddingBottom: '100%',
    width: '100%',
    minWidth: '100%',
    backgroundSize: 'cover',
    minHeight: '10px'
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }